import React from 'react';
import { Helmet } from 'react-helmet-async';
//import { Helmet } from 'react-helmet';

const SEO = ({ pageTitle, font }) => (
  <>
    <Helmet>
      <title>{pageTitle}</title>
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta name="description" content="Generated by create next app" />
      <meta name="robots" content="noindex, follow" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <link rel="stylesheet" href={font} />
      <link rel="icon" href="/ev.png" />
    </Helmet>
  </>
);

export default SEO;